import React from 'react';
import { Box, CircularProgress, Typography } from "@mui/material";

import AppTable from "components/Shared/AppTable";
import AppTableDateTime from "components/Shared/AppTableDateTime";

import { useTablePagination } from "hooks";
import { usePrepaymentDetailContext } from "contexts/PrepaymentDetailContext";
import { useLazyGetPrepaymentTransactionHistoryQuery } from "store/services/PaymentsApi/prepaymentApi";

const PrepaymentTransactionHistory = () => {
  const { prepaymentDetail } = usePrepaymentDetailContext();
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } = useTablePagination();

  const [fetchTransactions, { data: transactionRes, isLoading, isFetching }] =
    useLazyGetPrepaymentTransactionHistoryQuery();

  const columns = [
    {
      name: "Prepayment ID",
      selector: (row) => row.prepaymentID,
      cell: (row) => row.prepaymentID,
      width: "150px",
    },
    {
      name: "Shipment ID",
      selector: (row) => row.shipmentId,
      cell: (row) => row.shipmentId,
      width: "150px",
    },
    {
      name: "Charge",
      selector: (row) => row.charge,
      cell: (row) => `Rs. ${row.charge.toFixed(2)}`,
    },
    {
      name: "Balance Before",
      selector: (row) => row.balanceBefore,
      cell: (row) => `Rs. ${row.balanceBefore.toFixed(2)}`,
    },
    {
      name: "Balance After",
      selector: (row) => row.balanceAfter,
      cell: (row) => `Rs. ${row.balanceAfter.toFixed(2)}`,
    },
    {
      name: "Created By",
      selector: (row) => row.createdBy?.name || "N/A",
      cell: (row) => row.createdBy?.name || "N/A",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => <AppTableDateTime date={row.createdAt} />,
    },
  ];

  React.useEffect(() => {
    if (!prepaymentDetail?._id) return;
    fetchTransactions({
      prepaymentId: prepaymentDetail._id,
      page: currentPage,
      limit: perPage,
    });
  }, [currentPage, perPage, prepaymentDetail, fetchTransactions]);

  return (
    <Box>
      {transactionRes ? (
        <AppTable
          columns={columns}
          data={transactionRes?.transactions || []}
          progressPending={isLoading || isFetching}
          paginationServer
          paginationPerPage={perPage}
          paginationTotalRows={transactionRes?.totalItems || 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          noDataComponent={<Typography>No transactions found.</Typography>}
        />
      ) : (
        <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
          <CircularProgress size={24} />
          <Typography variant="body2" marginLeft={1}>Loading Transactions...</Typography>
        </Box>
      )}
    </Box>
  );
};

export default PrepaymentTransactionHistory;